import { render, staticRenderFns } from "./EncartesAtivos.vue?vue&type=template&id=176c10ba"
import script from "./EncartesAtivos.vue?vue&type=script&lang=js"
export * from "./EncartesAtivos.vue?vue&type=script&lang=js"
import style0 from "./EncartesAtivos.vue?vue&type=style&index=0&id=176c10ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports